var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "popup" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleDrawer,
            expression: "visibleDrawer",
          },
        ],
        staticClass: "popupBox",
        class: {
          "pop-up": true,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "pop-up-content",
            on: { mousedown: _vm.allowTextSelection },
          },
          [
            _vm._t("default"),
            _c("Sell", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === 1,
                  expression: "type === 1",
                },
              ],
              ref: "sellRef",
              on: { selectItem: _vm.selectItem, close: _vm.handleClose },
            }),
            _c("Collect", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === 2,
                  expression: "type === 2",
                },
              ],
              ref: "collectRef",
              on: { selectItem: _vm.selectItem, close: _vm.handleClose },
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }